export default __webpack_public_path__ + "static/media/304.826a616c.png";